import React from 'react'
import imglogo from '../../../assets/img/logo_t4i.png'
import bgAuthenticate from '../../../assets/img/bg-authenticate.png'

export function AuthShell({ title, subtitle, children, footer }) {
  return (
    <div className="login">
      <div className="hero-split">
        <img alt="Tech4Inventory Warehouse" className="hero-image" src={bgAuthenticate} />
      </div>
      <div className="form-split">
        <div className="form-container">
          <div className="form-container_top">
            <img alt="Tech4Inventory Logo" className="logo" src={imglogo} />
            <h1 className="title-app">Tech4Inventory</h1>
            <span className="subtitle-app">{title}</span>
            {subtitle ? <p className="auth-shell__subtitle">{subtitle}</p> : null}
          </div>
          <div className="form">
            <div className="theinputs">{children}</div>
            {footer}
          </div>
        </div>
      </div>
    </div>
  )
}
